import axios from 'axios'

const state = {
    categories: null,
    expandedCategories: null,
    selectOptions: [],
    expandedOptions: null,
}
  
const mutations = {
    setCategories (state, val) {
        state.categories = val;
    },
    setExpandedCategories (state, val) {
        state.expandedCategories = val;
    },
    setSelectOptions(state, val){
        state.selectOptions = val;
    },
    setExpandedOptions(state, val){
        state.expandedOptions = val;
    }
}
  
const actions = {
    getCategories({dispatch, commit , state}){
        axios.get('api/categories/getCategories')
        .then(async axRes => {
            commit('setCategories', axRes.data);
            var options = await dispatch('buildCats', {cats: axRes.data});
            commit('setSelectOptions', options);
            var expanded = await dispatch('expandeCategories', {cats: axRes.data});
            var parsed = {};
            for(var i in expanded){
                parsed[expanded[i].uuid] = expanded[i];
            }
            commit('setExpandedCategories', parsed);
            var parsedOpt = {};
            for(var i in options){
                parsedOpt[options[i].id] = options[i];
            }
            commit('setExpandedOptions', parsedOpt);
        }).catch(axErr => {
            console.log('axErr',axErr)
        })
    },
    async buildCats({dispatch}, {cats, excludedUuid}){
        var categories = [];
        for(var i in cats){
            if(!excludedUuid || cats[i].uuid != excludedUuid){
                var c = {
                    id: cats[i].uuid,
                    description: cats[i].title,
                    childrens : await dispatch('getCatChild',{c: cats[i], l : 1, x: excludedUuid})
                };
                categories.push(c);
                for(var i in c.childrens){
                    categories.push(c.childrens[i]);
                }
            }
        }
        return categories;
    },
    async getCatChild({dispatch},{c,l,x}){
        var childs = [];
        var level = '-'.repeat(l);
        for(var i in c.children){
            if(!x || c.children[i].uuid != x){
                var cc = { 
                    id: c.children[i].uuid, 
                    description: level + ' '+c.children[i].title,
                    childrens : await dispatch('getCatChild',{c: c.children[i], l: l+1})
                };
                childs.push(cc);
                childs = childs.concat(cc.childrens);
            }
        }
        return childs;
    },
    async expandeCategories({dispatch},{cats}){
        var categories = [];
        for(var i in cats){
            categories.push(cats[i]);
            categories = categories.concat(await dispatch('expandeCategories', {cats:cats[i].children}));
        }
        return categories;
    }
}
    
  
export default {
    state,
    mutations,
    actions,
}